import { fetchCurrentProfileAuthorizedSharingInfoApi } from 'api/profile/fetchCurrentAuthorizedSharingInfoApi'

export const FETCH_CURRENT_AUTHORIZED_PROFILE_SHARING_INFO =
  'FETCH_CURRENT_AUTHORIZED_PROFILE_SHARING_INFO' as const

export const fetchCurrentAuthorizedProfileSharingInfoAction = () => ({
  type: FETCH_CURRENT_AUTHORIZED_PROFILE_SHARING_INFO,
  promise: () => fetchCurrentProfileAuthorizedSharingInfoApi(),
})
